module.exports = __webpack_public_path__ + "img/ai-img-service.28b9a95b.png";